import TKTracker, { TrackerOptions } from '@tk/components/tracker/tk.tracker';
import GoogleTracker from '@tk/components/tracker/tk.google.tracker';
import MatomoTracker from '@tk/components/tracker/tk.matomo.tracker';

// Registry of tracker
TKTracker.registerTracker(
    'google',
    async (trackingId: string, options?: TrackerOptions) => new GoogleTracker(trackingId, options),
);
TKTracker.registerTracker(
    'matomo',
    async (trackingId: string, options?: TrackerOptions) => new MatomoTracker(trackingId, options),
);